"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FinApiPaymentStatusEnum = void 0;
var FinApiPaymentStatusEnum;
(function (FinApiPaymentStatusEnum) {
    FinApiPaymentStatusEnum["OPEN"] = "OPEN";
    FinApiPaymentStatusEnum["PENDING"] = "PENDING";
    FinApiPaymentStatusEnum["SUCCESSFUL"] = "SUCCESSFUL";
    FinApiPaymentStatusEnum["NOT_SUCCESSFUL"] = "NOT_SUCCESSFUL";
    FinApiPaymentStatusEnum["DISCARDED"] = "DISCARDED";
})(FinApiPaymentStatusEnum || (exports.FinApiPaymentStatusEnum = FinApiPaymentStatusEnum = {}));
